import { Navigate } from 'react-router-dom';
import React, { FC, PropsWithChildren } from 'react';
import { useAtomValue } from 'jotai';
import { portalLoginStatus, portalSso } from '@/state/portalAuth';
import routes from '@/components/portal/routes';
import EventAwareRoute from '@/components/portal/EventAwareRoute';

export type AuthenticatedRouteProps = PropsWithChildren;

/**
 * Guards its children, redirecting to the login page if the current user is logged out.
 */
const AuthenticatedRoute: FC<AuthenticatedRouteProps> = ({ children }) => {
  const loginStatus = useAtomValue(portalLoginStatus);
  const sso = useAtomValue(portalSso);

  switch (loginStatus) {
    case 'LOGGED_OUT':
      if (sso?.registrationId) {
        return (
          <Navigate
            to={routes.sessionExpiredSso.replace(
              ':registrationId',
              sso.registrationId,
            )}
            replace
          />
        );
      }

      return <Navigate to={routes.login} replace />;
    case 'AUTHENTICATED':
      return <EventAwareRoute>{children}</EventAwareRoute>;
    default:
      return <>{children}</>;
  }
};

export default AuthenticatedRoute;
